// extracted by mini-css-extract-plugin
export default {"button-box":"Login_button-box__b4Cea","forgot":"Login_forgot__Odqk1","input-box":"Login_input-box__k1-O-","window":"Login_window__cw6an"};